(function () {
  function swiperInit() {
    subSliderInit(true);
    sliderInit(true);
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit();
  });

  const desktopGalleryQuery = window.matchMedia("(min-width: 990px)");

  function handleGalleryBreakpointChange() {
    document
      .querySelectorAll('[data-gallery-diverged="true"]')
      .forEach(function (wrapper) {
        wrapper
          .querySelectorAll(".js-media-list, .js-media-sublist")
          .forEach(function (el) {
            if (el.offsetParent === null && el.swiper) {
              el.swiper.destroy(true, true);
              delete el.dataset.swiperInitialized;
            }
          });
      });

    swiperInit();
  }

  if (desktopGalleryQuery.addEventListener) {
    desktopGalleryQuery.addEventListener(
      "change",
      handleGalleryBreakpointChange
    );
  } else if (desktopGalleryQuery.addListener) {
    // Safari < 14
    desktopGalleryQuery.addListener(handleGalleryBreakpointChange);
  }

  swiperInit();
})();
